[
  {
    "id": 194,
    "documentId": "yrtj6t1poswp6jp86u6mnsz2",
    "name": "React Native",
    "slug": "react-native",
    "description": "Cross-platform mobile development with TypeScript and JavaScript",
    "tags": [
      "cross-platform",
      "typescript",
      "javascript"
    ],
    "proficiencyLevel": "expert",
    "yearsOfExperience": 4,
    "icon": "react-native",
    "link": "https://reactnative.dev",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.018Z",
    "updatedAt": "2025-08-05T12:23:58.018Z",
    "publishedAt": "2025-08-05T12:23:58.023Z",
    "categories": [
      {
        "id": 410,
        "name": "mobile-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 196,
    "documentId": "llh2fyxcrgr4svb2hv04cv4m",
    "name": "Flutter",
    "slug": "flutter",
    "description": "Google's UI toolkit for building natively compiled applications",
    "tags": [
      "cross-platform",
      "dart",
      "ui"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "flutter",
    "link": "https://flutter.dev",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.039Z",
    "updatedAt": "2025-08-05T12:23:58.039Z",
    "publishedAt": "2025-08-05T12:23:58.042Z",
    "categories": [
      {
        "id": 412,
        "name": "mobile-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 198,
    "documentId": "wokqaffr543u07vc7xe21qxn",
    "name": "Kotlin",
    "slug": "kotlin",
    "description": "Modern programming language for Android development",
    "tags": [
      "android",
      "native",
      "jvm"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "kotlin",
    "link": "https://kotlinlang.org",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.059Z",
    "updatedAt": "2025-08-05T12:23:58.059Z",
    "publishedAt": "2025-08-05T12:23:58.062Z",
    "categories": [
      {
        "id": 414,
        "name": "mobile-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 200,
    "documentId": "wmjsv5codha80phr85rhzbd7",
    "name": "SwiftUI",
    "slug": "swiftui",
    "description": "Modern declarative UI framework for iOS development",
    "tags": [
      "ios",
      "native",
      "swift"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "swift",
    "link": "https://developer.apple.com/xcode/swiftui",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.078Z",
    "updatedAt": "2025-08-05T12:23:58.078Z",
    "publishedAt": "2025-08-05T12:23:58.080Z",
    "categories": [
      {
        "id": 416,
        "name": "mobile-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 202,
    "documentId": "xyzhqu0c5ab5ts3ybr9dmubj",
    "name": "React.js",
    "slug": "react-js",
    "description": "JavaScript library for building user interfaces",
    "tags": [
      "frontend",
      "javascript",
      "ui"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "react",
    "link": "https://reactjs.org",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.097Z",
    "updatedAt": "2025-08-05T12:23:58.097Z",
    "publishedAt": "2025-08-05T12:23:58.101Z",
    "categories": [
      {
        "id": 418,
        "name": "web-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 204,
    "documentId": "wqf7uj0w38s2h4nx4f35h0qu",
    "name": "Next.js",
    "slug": "next-js",
    "description": "React framework for production",
    "tags": [
      "react",
      "ssr",
      "fullstack"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "nextjs",
    "link": "https://nextjs.org",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.115Z",
    "updatedAt": "2025-08-05T12:23:58.115Z",
    "publishedAt": "2025-08-05T12:23:58.118Z",
    "categories": [
      {
        "id": 420,
        "name": "web-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 206,
    "documentId": "fg2bu9p5wfp2tiqbjt3pc6yh",
    "name": "TypeScript",
    "slug": "typescript",
    "description": "Typed superset of JavaScript",
    "tags": [
      "javascript",
      "typed",
      "microsoft"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "typescript",
    "link": "https://www.typescriptlang.org",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.131Z",
    "updatedAt": "2025-08-05T12:23:58.131Z",
    "publishedAt": "2025-08-05T12:23:58.135Z",
    "categories": [
      {
        "id": 422,
        "name": "programming-languages"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 208,
    "documentId": "xp16c9ph5lgau5d0r1quxjq5",
    "name": "Node.js",
    "slug": "node-js",
    "description": "JavaScript runtime for server-side development",
    "tags": [
      "javascript",
      "runtime",
      "server"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "nodejs",
    "link": "https://nodejs.org",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.150Z",
    "updatedAt": "2025-08-05T12:23:58.150Z",
    "publishedAt": "2025-08-05T12:23:58.152Z",
    "categories": [
      {
        "id": 424,
        "name": "backend-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 210,
    "documentId": "vd46y16zs8txh2erwpu2rwxx",
    "name": "Express.js",
    "slug": "express-js",
    "description": "Fast, unopinionated web framework for Node.js",
    "tags": [
      "nodejs",
      "web-framework",
      "api"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "express",
    "link": "https://expressjs.com",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.167Z",
    "updatedAt": "2025-08-05T12:23:58.167Z",
    "publishedAt": "2025-08-05T12:23:58.170Z",
    "categories": [
      {
        "id": 426,
        "name": "frameworks"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 212,
    "documentId": "qiaifxd6usyjoldbk36dn4h5",
    "name": ".NET",
    "slug": "dotnet",
    "description": "Microsoft's cross-platform development framework",
    "tags": [
      "microsoft",
      "csharp",
      "framework"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "dotnet",
    "link": "https://dotnet.microsoft.com",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.185Z",
    "updatedAt": "2025-08-05T12:23:58.185Z",
    "publishedAt": "2025-08-05T12:23:58.187Z",
    "categories": [
      {
        "id": 428,
        "name": "backend-development"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 214,
    "documentId": "onqbxgoh55qu3nv0pqenugfn",
    "name": "Go",
    "slug": "go",
    "description": "Open source programming language by Google",
    "tags": [
      "google",
      "backend",
      "performance"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 1,
    "icon": "go",
    "link": "https://golang.org",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.203Z",
    "updatedAt": "2025-08-05T12:23:58.203Z",
    "publishedAt": "2025-08-05T12:23:58.205Z",
    "categories": [
      {
        "id": 430,
        "name": "programming-languages"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 216,
    "documentId": "g26kwlq7xrhsvrs9dnyok2ir",
    "name": "PostgreSQL",
    "slug": "postgresql",
    "description": "Advanced open source relational database",
    "tags": [
      "sql",
      "relational",
      "open-source"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "postgresql",
    "link": "https://www.postgresql.org",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.222Z",
    "updatedAt": "2025-08-05T12:23:58.222Z",
    "publishedAt": "2025-08-05T12:23:58.225Z",
    "categories": [
      {
        "id": 432,
        "name": "databases"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 218,
    "documentId": "m6oo8zzerqo55kl6t0adb9ox",
    "name": "MongoDB",
    "slug": "mongodb",
    "description": "Document-oriented NoSQL database",
    "tags": [
      "nosql",
      "document",
      "json"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "mongodb",
    "link": "https://www.mongodb.com",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.256Z",
    "updatedAt": "2025-08-05T12:23:58.256Z",
    "publishedAt": "2025-08-05T12:23:58.259Z",
    "categories": [
      {
        "id": 434,
        "name": "databases"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 220,
    "documentId": "tqw8q9jbi7ri01mwuxvq9j3s",
    "name": "AWS",
    "slug": "aws",
    "description": "Amazon Web Services cloud platform",
    "tags": [
      "cloud",
      "amazon",
      "infrastructure"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "aws",
    "link": "https://aws.amazon.com",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.277Z",
    "updatedAt": "2025-08-05T12:23:58.277Z",
    "publishedAt": "2025-08-05T12:23:58.280Z",
    "categories": [
      {
        "id": 436,
        "name": "cloud-platforms"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 222,
    "documentId": "xtmxno4yrfcd2sc9gcsqm600",
    "name": "Docker",
    "slug": "docker",
    "description": "Containerization platform for applications",
    "tags": [
      "containers",
      "deployment",
      "devops"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "docker",
    "link": "https://www.docker.com",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.293Z",
    "updatedAt": "2025-08-05T12:23:58.293Z",
    "publishedAt": "2025-08-05T12:23:58.295Z",
    "categories": [
      {
        "id": 438,
        "name": "devops"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 224,
    "documentId": "dzsbr2cw7c660ekq4963zd0o",
    "name": "Kubernetes",
    "slug": "kubernetes",
    "description": "Container orchestration platform",
    "tags": [
      "orchestration",
      "containers",
      "scaling"
    ],
    "proficiencyLevel": "beginner",
    "yearsOfExperience": 1,
    "icon": "kubernetes",
    "link": "https://kubernetes.io",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.310Z",
    "updatedAt": "2025-08-05T12:23:58.310Z",
    "publishedAt": "2025-08-05T12:23:58.312Z",
    "categories": [
      {
        "id": 440,
        "name": "devops"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 226,
    "documentId": "iyy0sxxwyteo07ajkbt3yc11",
    "name": "Clean Architecture",
    "slug": "clean-architecture",
    "description": "Software architecture pattern for maintainable applications",
    "tags": [
      "architecture",
      "design-patterns",
      "maintainability"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 3,
    "icon": "architecture",
    "link": "https://blog.cleancoder.com/uncle-bob/2012/08/13/the-clean-architecture.html",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.326Z",
    "updatedAt": "2025-08-05T12:23:58.326Z",
    "publishedAt": "2025-08-05T12:23:58.329Z",
    "categories": [
      {
        "id": 442,
        "name": "architecture"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 228,
    "documentId": "szbzij6cxxrv8js5stcugfhc",
    "name": "Microservices",
    "slug": "microservices",
    "description": "Architectural style for distributed systems",
    "tags": [
      "architecture",
      "distributed",
      "scalability"
    ],
    "proficiencyLevel": "intermediate",
    "yearsOfExperience": 2,
    "icon": "microservices",
    "link": "https://microservices.io",
    "isActive": true,
    "isFeatured": false,
    "createdAt": "2025-08-05T12:23:58.344Z",
    "updatedAt": "2025-08-05T12:23:58.344Z",
    "publishedAt": "2025-08-05T12:23:58.346Z",
    "categories": [
      {
        "id": 444,
        "name": "architecture"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  },
  {
    "id": 230,
    "documentId": "mcaav5yx8wvx2c0uqu4fv3ix",
    "name": "Agile/Scrum",
    "slug": "agile-scrum",
    "description": "Agile project management methodology",
    "tags": [
      "project-management",
      "agile",
      "scrum"
    ],
    "proficiencyLevel": "advanced",
    "yearsOfExperience": 4,
    "icon": "agile",
    "link": "https://www.scrum.org",
    "isActive": true,
    "isFeatured": true,
    "createdAt": "2025-08-05T12:23:58.360Z",
    "updatedAt": "2025-08-05T12:23:58.360Z",
    "publishedAt": "2025-08-05T12:23:58.363Z",
    "categories": [
      {
        "id": 446,
        "name": "project-management"
      }
    ],
    "certifications": [],
    "projects": [],
    "experiences": []
  }
]
